import type { RegistrationStepId } from "@buxus/shared";

/** UI wizard steps (includes quick-code substeps not in the step engine). */
export type RegistrationUiStep =
  | "quickCode"
  | "quickCodeEntry"
  | "expressReturnQuickCode"
  | "quickCodeAlreadyRegistered"
  | "accountBasics"
  | "mailing"
  | "jurisdictions"
  | "organization"
  | "agencyInfo"
  | "agencyCapability"
  | "agencyProcedure"
  | "agencyTraining"
  | "dispatchCapabilities"
  | "agencyAgreement"
  | "additionalQuestions"
  | "done";

const UI_TO_ENGINE: Partial<Record<RegistrationUiStep, RegistrationStepId>> = {
  accountBasics: "account",
  mailing: "mailing",
  jurisdictions: "jurisdictions",
  organization: "organization",
  agencyInfo: "agencyInfo",
  agencyCapability: "agencyCapability",
  agencyProcedure: "agencyProcedure",
  agencyTraining: "agencyTraining",
  dispatchCapabilities: "dispatchCapabilities",
  agencyAgreement: "agencyAgreement",
  additionalQuestions: "additionalQuestions",
};

const ENGINE_TO_UI: Record<RegistrationStepId, RegistrationUiStep | null> = {
  quickCode: "quickCode",
  account: "accountBasics",
  mailing: "mailing",
  jurisdictions: "jurisdictions",
  organization: "organization",
  agencyInfo: "agencyInfo",
  agencyCapability: "agencyCapability",
  agencyProcedure: "agencyProcedure",
  agencyTraining: "agencyTraining",
  dispatchCapabilities: "dispatchCapabilities",
  agencyAgreement: "agencyAgreement",
  additionalQuestions: "additionalQuestions",
};

export function uiStepToEngineStep(step: RegistrationUiStep): RegistrationStepId | null {
  return UI_TO_ENGINE[step] ?? null;
}

export function engineStepToUiStep(stepId: RegistrationStepId): RegistrationUiStep {
  return ENGINE_TO_UI[stepId] ?? "accountBasics";
}
